import React, { useContext } from "react";
import "./loadingPopup.css";
import loadingImg from "../../images/loading.svg";
import { AuthContext } from "../../AuthProvider";

export const LoadingPopup = () => {
  const { isMobileAuth } = useContext(AuthContext);

  return (
    <div className="container-popup">
      <div className="popup-loading-title">
        <div className="loading-popup">
          <img src={loadingImg} alt="Imagem de carregamento da página"></img>
        </div>
        <br />
        {!isMobileAuth && <h3>Validação de acesso em curso. Por favor, aguarde.</h3>}
      </div>
    </div>
  );
};
